import auth from '@/router/auth'
import BookingIndex from '@/components/bookings/Index'
import BookingCreate from '@/components/bookings/Create'
import BookingUpdate from '@/components/bookings/Update'
import BookingShow from '@/components/bookings/Show'

export default [
  {
    path: '/bookings',
    name: 'bookings-index',
    component: BookingIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/bookings/create',
    name: 'bookings-create',
    component: BookingCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/bookings/update/:course_id',
    name: 'bookings-update',
    component: BookingUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/bookings/show/:course_id',
    name: 'bookings-show',
    component: BookingShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/bookings/router.js